module.exports = __webpack_public_path__ + "static/media/tencent-weibo.a38f2844.svg";